import PropTypes from 'prop-types';
import FJTextAreaTextToImage from './FJTextAreaTextToImage';
import styles from './FJTextToImagePrompt.module.less';
import FJTextToImageConstant from '../../../../constants/FJTextToImageConstant';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import { useState } from 'react';
import { useEffect } from 'react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';

const FJTextToImagePrompt = props => {
    const {
        prompt,
        changePrompt,
        promptStatus,
        showUploadImageAsPromptModal,
        imageUrl,
        onCancel,
        getInspire,
        aiOptimizing,
    } = props;

    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const onLoadImage = () => {
        setIsImageLoaded(true);
    };

    const onErrorImage = () => {
        setIsImageLoaded(false);
    };

    useEffect(() => {
        if (imageUrl) {
            setIsImageLoaded(false);
        }
    }, [imageUrl]);

    return (
        <div className={styles.prompt_box}>
            <div className={styles.prompt_title}>{FJLocalStore._('prompt')}</div>
            <FJTextAreaTextToImage
                text={prompt}
                onChange={changePrompt}
                maxLength={FJTextToImageDataConfig.PROMPT_TEXT_LIMIT}
                placeholder={FJLocalStore._(FJTextToImageDataConfig.PROMPT_PLACEHOLDER)}
                showUploadImageAsPromptModal={showUploadImageAsPromptModal}
                getInspire={getInspire}
                aiOptimizing={aiOptimizing}
                aiPromptDisabled={promptStatus !== FJTextToImageConstant.NORMAL}
            />

            {promptStatus === FJTextToImageConstant.AI_OPTIMIZING && (
                <div className={styles.ai_optimizing_box}>
                    <FJLoading className={styles.ai_optimizing_loading} />
                    <div className={styles.ai_optimizing}>{FJLocalStore._('ai-optimizing')}</div>
                    <div className={styles.ai_image_importing_cancel_btn} onClick={onCancel}>
                        {FJLocalStore._('cancel')}
                    </div>
                </div>
            )}

            {promptStatus === FJTextToImageConstant.IMAGE_IMPORTING && (
                <div className={styles.ai_image_importing_box}>
                    <div className={styles.ai_image_importing_image}>
                        <img
                            src={imageUrl}
                            alt=''
                            onLoad={onLoadImage}
                            onError={onErrorImage}
                            className={classNames({
                                [styles.ai_image_to_prompt_hide]: !isImageLoaded,
                            })}
                        />
                        <div className={styles.ai_image_importing_shadow_box}></div>
                        <FJLoading className={styles.ai_image_importing_loading} />
                    </div>
                    <div className={styles.ai_image_importing_text}>{FJLocalStore._('image-recognition')}</div>

                    <div className={styles.ai_image_importing_cancel_btn} onClick={onCancel}>
                        {FJLocalStore._('cancel')}
                    </div>
                </div>
            )}
        </div>
    );
};

FJTextToImagePrompt.propTypes = {
    prompt: PropTypes.string,
    changePrompt: PropTypes.func,
    promptStatus: PropTypes.string,
    showUploadImageAsPromptModal: PropTypes.func,
    imageUrl: PropTypes.string,
    onCancel: PropTypes.func,
    getInspire: PropTypes.func,
    aiOptimizing: PropTypes.func,
};

export default FJTextToImagePrompt;
